import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import APPCONFIG from "constants/Config";
import CollectionOverride from "components/CollectionOverride";



export default class Emails extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Changes_Emails._name, API.RequestType.READ_ALL);
		super(props, model);

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Date Sent",
				id: "date",
				width: 250,
				/** @param {Changes_Emails_Object} obj */
				accessor: obj => {
					return obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "Email Sent",
				id: "template",
				/** @param {Changes_Emails_Object} obj */
				accessor: obj => (obj.email_templates.name)
			},
			{
				Header: "Email Address",
				id: "email",
				/** @param {Changes_Emails_Object} obj */
				accessor: obj => (obj.email)
			},
			{
				Header: "User",
				id: "user",
				/** @param {Changes_Emails_Object} obj */
				accessor: obj => (obj.user ? obj.user : 'Owner')
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<a href={APPCONFIG.settings.apiURL() + "/" + APPCONFIG.settings.apiVersion + "/changes/emails/" + `${props.original._id}`}
							   target={'_blank'}>
								<Button color="green-meadow" size="sm" block={true}>
									<i className="fa fa-envelope-o"/>
								</Button>
							</a>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Emails', "")}
							{this.renderHeaderRight("Emails", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
